import { rem } from '@mantine/core';
import { brandTypography } from 'theme/brand-tokens';

export const H1Medium = {
  fontSize: rem(brandTypography.h1Medium.fontSize),
  fontWeight: brandTypography.h1Medium.fontWeight,
  lineHeight: rem(brandTypography.h1Medium.lineHeight),
};

export const H2Medium = {
  fontSize: rem(brandTypography.h2Medium.fontSize),
  fontWeight: brandTypography.h2Medium.fontWeight,
  lineHeight: rem(brandTypography.h2Medium.lineHeight),
};

export const H2Regular = {
  fontSize: rem(brandTypography.h2Regular.fontSize),
  fontWeight: brandTypography.h2Regular.fontWeight,
  lineHeight: rem(brandTypography.h2Regular.lineHeight),
};

export const H3Medium = {
  fontSize: rem(brandTypography.h3Medium.fontSize),
  fontWeight: brandTypography.h3Medium.fontWeight,
  lineHeight: rem(brandTypography.h3Medium.lineHeight),
};

export const P1Regular = {
  fontSize: rem(brandTypography.p1Regular.fontSize),
  fontWeight: brandTypography.p1Regular.fontWeight,
  lineHeight: rem(brandTypography.p1Regular.lineHeight),
};

export const P1RegularLink = {
  fontSize: rem(brandTypography.p1Regular.fontSize),
  fontWeight: brandTypography.p1Regular.fontWeight,
  lineHeight: rem(brandTypography.p1Regular.lineHeight),
  textDecoration: 'underline',
};

export const P1Medium = {
  fontSize: rem(brandTypography.p1Medium.fontSize),
  fontWeight: brandTypography.p1Medium.fontWeight,
  lineHeight: rem(brandTypography.p1Medium.lineHeight),
};

export const P2Regular = {
  fontSize: rem(brandTypography.p2Regular.fontSize),
  fontWeight: brandTypography.p2Regular.fontWeight,
  lineHeight: rem(brandTypography.p2Regular.lineHeight),
};

export const P2RegularLink = {
  fontSize: rem(brandTypography.p2Regular.fontSize),
  fontWeight: brandTypography.p2Regular.fontWeight,
  lineHeight: rem(brandTypography.p2Regular.lineHeight),
  textDecoration: 'underline',
};

export const P2Medium = {
  fontSize: rem(brandTypography.p2Medium.fontSize),
  fontWeight: brandTypography.p2Medium.fontWeight,
  lineHeight: rem(brandTypography.p2Medium.lineHeight),
};

export const P3Regular = {
  fontSize: rem(brandTypography.p3Regular.fontSize),
  fontWeight: brandTypography.p3Regular.fontWeight,
  lineHeight: rem(brandTypography.p3Regular.lineHeight),
};

export const P3Medium = {
  fontSize: rem(brandTypography.p3Medium.fontSize),
  fontWeight: brandTypography.p3Medium.fontWeight,
  lineHeight: rem(brandTypography.p3Medium.lineHeight),
};

export const P4Regular = {
  fontSize: rem(brandTypography.p4Regular.fontSize),
  fontWeight: brandTypography.p4Regular.fontWeight,
  lineHeight: rem(brandTypography.p4Regular.lineHeight),
};

export const P4Medium = {
  fontSize: rem(brandTypography.p4Medium.fontSize),
  fontWeight: brandTypography.p4Medium.fontWeight,
  lineHeight: rem(brandTypography.p4Medium.lineHeight),
};
